'use strict';

intellidealerAppEquipmentModule.config(['$stateProvider', function ($stateProvider) {
  $stateProvider.state(
    'navigation.equipment.equipmentForSale.equipmentForSaleDetails.groundEngaging', {
      url: '/ground-engaging',
      templateUrl: 'app/scripts/modules/equipment/views/ground-engaging.html'
    }
  );

  $stateProvider.state(
    'public.equipment.equipmentForSale.equipmentForSaleDetails.groundEngaging', {
      url: '/ground-engaging',
      templateUrl: 'app/scripts/modules/equipment/views/ground-engaging.html'
    }
  );
}]);
